import React, {PureComponent} from 'react';

import SideModal from './SideModal';
import Button from './Button';
import Form from './Form';
import ReportParameterInput from './ReportParameterInput';

class ReportParametersModal extends PureComponent {
  state = {
    valueByParameterName: deserializeParameters(this.props.report, this.props.parameters),
    validationEnabled: false
  };

  componentDidUpdate(prevProps) {
    const {report, parameters} = this.props;
    
    if (prevProps.report !== report || prevProps.parameters !== parameters) {
      this.setState({
        valueByParameterName: deserializeParameters(report, parameters),
        validationEnabled: false
      });
    }
  }

  handleParameterChange = (parameter, value) => {
    this.setState(prevState => ({
      valueByParameterName: {
        ...prevState.valueByParameterName,
        [parameter.name]: value
      }
    }));
  }

  handleRunReport = () => {
    const {report, onRun} = this.props;
    const {valueByParameterName} = this.state;
    const errors = getValidationErrors(report, valueByParameterName);

    if (Object.keys(errors).length > 0) {
      // Some parameters are missing, so bail.
      this.setState({validationEnabled: true});
      return;
    }

    onRun(report, serializeParameters(valueByParameterName));
  }

  renderParameters() {
    const {report, catalog} = this.props;
    const {valueByParameterName, validationEnabled} = this.state;
    const validations = validationEnabled ? getValidationErrors(report, valueByParameterName) : {};

    return report.parameters.map(parameter => (
      <Form.Group key={parameter.name}>
        <ReportParameterInput
          report={report}
          catalog={catalog}
          parameter={parameter}
          value={valueByParameterName[parameter.name]}
          validationText={validations[parameter.name]}
          onChange={this.handleParameterChange}
        />
      </Form.Group>
    ));
  }
  
  render() {
    const {report, onClose} = this.props;
    const {valueByParameterName, validationEnabled} = this.state;
    const errors = report && validationEnabled ? getValidationErrors(report, valueByParameterName) : {};

    return (
      <Form onSubmit={this.handleRunReport}>
        <SideModal
          open={report}
          title={report && report.name}
          onClose={onClose}
          options={[
            <Button type="submit" disabled={Object.keys(errors).length > 0}>Run Report</Button>,
            <Button secondary onClick={onClose}>Cancel</Button>
          ]}>
          <SideModal.Content>
            {report && this.renderParameters()}
          </SideModal.Content>
        </SideModal>
      </Form>
    );
  }
}

function getValidationErrors(report, values) {
  return report.parameters.reduce((map, parameter) => {
    if (!values[parameter.name] && !parameter.allowBlank) {
      map[parameter.name] = 'This parameter is required.';
    }

    return map;
  }, {});
}

// Converts this component's internal representation of parameters into values that the reporting service understands.
function serializeParameters(parameters) {
  return Object.keys(parameters)
    .reduce((map, key) => {
      if (parameters[key] instanceof Date) {
        map[key] = parameters[key].getTime();
      }
      else {
        map[key] = parameters[key];
      }

      return map;
    }, {});
}

// Converts serialized values of parameters back into this component's internal representation.
function deserializeParameters(report, parameters) {
  if (!report || !parameters) {
    return {};
  }

  return report.parameters.reduce((map, parameter) => {
    if(parameters[parameter.name]){
      switch (true) {
        case parameter.name === 'date':
        case parameter.name === 'start_date':
        case parameter.name === 'end_date':
        case parameter.dataType === 4 :
        case parameter.dataType === 7 :
          map[parameter.name] = new Date(parseInt(parameters[parameter.name], 10));
          break;

        default:
          map[parameter.name] = parameters[parameter.name];
      }
    }

    return map;
  }, {});
}

export default ReportParametersModal;